import {useState} from 'react'
import CodeMirror from '@uiw/react-codemirror';
import {javascript} from '@codemirror/lang-javascript';
import {html} from "@codemirror/lang-html";
import {Maximize, Minimize} from 'react-feather';


const CodeEditor = (options) => {

    const placeholder = options && options.placeholder ? options.placeholder : null
    const language = options && options.language ? options.language : 'HTML'
    const [darkTheme, setDarkTheme] = useState(true)
    const [fullScreen, setFullScreen] = useState(false)
    const [value, setValue] = useState(options && options.value != undefined ? options.value : placeholder);

    const CodeExtensions = [
        html({
            matchClosingTags: true,
            autoCloseTags: true
        }),
        javascript({
            jsx: false
        })
    ]

    const ThemeOptions = {
        label: 'Dark',
        value: darkTheme ? 'on' : 'off',
    }


    const activateFullScreen = (event) => {
        event.preventDefault();
        setFullScreen(true)
    }

    const desactivateFullScreen = (event) => {
        event.preventDefault();
        setFullScreen(false)
    }


    const handleThemeChange = () => {
        setDarkTheme(!darkTheme)
    }


    const CodeMirrorOptions = {
        value: value,
        height: "450px",
        language: language,
        indentWithTab: true,
        extensions: CodeExtensions,
        theme: 'light',
        onChange: (value, viewUpdate) => {

            if(options && typeof options.onChange == "function"){
                options.onChange(value)
            }

            setValue(value)
        },
        onBlur: (event) => {
            if(options && typeof options.onBlur == "function"){
                options.onBlur(event.target.innerText)
            }
        }
    }


    if(options){
        if(options.maxWidth){
            CodeMirrorOptions.maxWidth = options.maxWidth
        }
    }



    let className = fullScreen ? 'CodeEditor CodeFull' : 'CodeEditor';
    if(options?.overflow === "auto"){
        className += " CodeScroll"
    }



    return (
        <div className={className}>
            {options && options.tools != false && <div className="CodeTools">
                <ul className="list-inline list-unstyled">
                    <li className="list-inline-item">
                        {
                            !fullScreen && <button className="btn-toolbar btn-primary" onClick={(event) => {activateFullScreen(event);}}>
                                <Maximize/>
                            </button>
                        }

                        {
                            fullScreen && <button className="btn-toolbar btn-primary" onClick={(event) => {desactivateFullScreen(event);}}>
                                <Minimize/>
                            </button>
                        }

                    </li>
                </ul>
            </div>}

            <CodeMirror {...CodeMirrorOptions} />
            <input type="hidden" name={options.name} value={value}/>
        </div>
    )
}

export default CodeEditor;